import { render, staticRenderFns } from "./programacion-envios.vue?vue&type=template&id=40c40fcc"
import script from "./programacion-envios.vue?vue&type=script&lang=ts"
export * from "./programacion-envios.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports